import React from 'react';
import PropTypes from 'prop-types';
import Link from '@nerdwallet/react-link';
import { Text } from '@nerdwallet/react-typography';

var BottomLine = function BottomLine(_ref) {
  var bottomLineText = _ref.bottomLineText,
      reviewLink = _ref.reviewLink,
      reviewTarget = _ref.reviewTarget;
  return React.createElement("div", null, React.createElement(Text, {
    bold: true
  }, "The bottom line"), React.createElement(Text, {
    small: true
  }, "".concat(bottomLineText, " "), React.createElement(Link, {
    target: reviewTarget,
    href: reviewLink
  }, "Read full review.")));
};

BottomLine.propTypes = {
  bottomLineText: PropTypes.string,
  reviewLink: PropTypes.string,
  reviewTarget: PropTypes.string
};
export default BottomLine;